module.exports = __webpack_public_path__ + "03_mid_brown.08635f9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/03_mid_brown.png
// module id = 5rZ2
// module chunks = 0